import { ChangeDetectorRef, Component, Input } from '@angular/core';
import {Observable} from "rxjs";

@Component({
  selector: 'tabs',
  templateUrl: 'tabs.component.html',
  styleUrls: ['tabs.component.scss'],
  standalone: false
})
export class TabsComponent {
  @Input() items: TabItem[];
  @Input() padding = '14px';

  get linkStyle() {
    return {
      'padding-left': this.padding,
      'padding-right': this.padding
    };
  }

  constructor(private cdRef: ChangeDetectorRef) {}

  public setItems(items: TabItem[]) {
    this.items = items;
    this.cdRef.detectChanges();
  }
}

export interface TabItem {
  readonly label: string;
  readonly link: string;
  readonly icon: string;
  readonly exact?: boolean;
  readonly isHide?: Observable<boolean>;
}
